// Filename: About.js

import React, { useState } from "react";
import "./About.css";
// --- SWIPER IMPORTS ---
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
// ----------------------------------------------

// Defensive Imports: If data modules fail to load (common cause of 'split' error),
// the arrays safely default to [].

// --- FIX: Use named imports for data arrays. This resolves the 'undefined split' error
// that commonly occurs when default importing a file that uses named exports.
import teamMembers from "./AboutData.js";
import partners from "./tradePrtners.js";
import hotels from "./hotelPartners.js";
import reviews from "./Reviews.js";

// IMPORT YOUR HERO IMAGE - Replace with your actual path
import AboutHeroImage from "./AboutImages/aboutBanner.png";

// Assign the imported (and now correctly destructured) arrays, defaulting to []
// const teamMembers = teamMembersData || [];
// const partners = partnersData || [];
// const hotels = hotelsData || [];
// const reviews = reviewsData || [];

const Stars = ({ count }) => (
  <div className="stars">
    {Array.from({ length: 5 }).map((_, i) => (
      <span key={i} className={i < count ? "star filled" : "star"}>
        ★
      </span>
    ))}
  </div>
);

function About() {
  // Team Modal State
  const [selectedMember, setSelectedMember] = useState(null);
  const handleClose = () => setSelectedMember(null);

  // SWIPER Parameters for Partners and Hotels (4-card desktop, 2-card mobile)
  const swiperPartnersParams = {
    modules: [Pagination, Autoplay],
    spaceBetween: 20,
    slidesPerView: 4,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    pagination: {
      clickable: true,
      el: ".swiper-pagination-partners",
    },
    breakpoints: {
      1025: { slidesPerView: 4, spaceBetween: 20 },
      769: { slidesPerView: 3, spaceBetween: 15 },
      0: { slidesPerView: 2, spaceBetween: 10 }, // Mobile: Show 2 logos
    },
  };

  // SWIPER Parameters for the Reviews Carousel (3-card desktop, 1-card mobile)
  const swiperReviewParams = {
    modules: [Navigation, Pagination, Autoplay],
    spaceBetween: 20,
    slidesPerView: 3,
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".swiper-button-next-reviews",
      prevEl: ".swiper-button-prev-reviews",
    },
    pagination: {
      clickable: true,
      el: ".swiper-pagination-reviews",
      type: "bullets",
    },
    breakpoints: {
      1025: {
        // Desktop
        slidesPerView: 3,
        spaceBetween: 20,
      },
      769: {
        // Tablet
        slidesPerView: 2,
        spaceBetween: 15,
        centeredSlides: false,
      },
      0: {
        // Mobile: ONE CARD VIEW
        slidesPerView: 1.1, // Show 1 card + a partial view of the next one
        spaceBetween: 10,
        centeredSlides: true, // Center the active slide for a clean look
        navigation: false, // Disable arrows on mobile
      },
    },
  };

  // Review Card Component
  const ReviewCard = ({ review }) => {
    // Safety check for image source
    const photoSrc = review?.photo || "default-avatar-url.png";

    return (
      <div className="review-carousel-card">
        <div className="review-header">
          {/* <img
            src={photoSrc}
            alt={review.name}
            className="review-carousel-photo"
          /> */}
          <div className="review-info">
            <h4 className="review-carousel-name">{review.name}</h4>
            <Stars count={review.rating} />
          </div>
        </div>
        <p className="review-carousel-quote">"{review.text}"</p>
      </div>
    );
  };

  return (
    <>
      <div className="about-page-wrapper">
        {/* 1. HERO BANNER */}
        <div className="hero-banner-container">
          <img
            src={AboutHeroImage}
            alt="International Destinations Banner - World Landmarks"
            className="hero-banner-image"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src =
                "https://placehold.co/1920x450/004a80/ffffff?text=Discover+Your+Next+Adventure";
            }}
          />
          <div className="hero-content-overlay">
            <h1 className="hero-title">About US</h1>
            <p className="hero-subtitle">
              Exclusive Journeys. Exceptional Service.
            </p>
          </div>
        </div>

        <div className="about">
          {/* WHO WE ARE */}
          <div className="whoWeR">
            <h2 style={{ color: "Black" }}>Who We Are</h2>
            <p>
              <b>M D Tours and Travels</b> is a premier travel company based in
              Karnataka, dedicated to curating exceptional travel experiences
              across India and around the world. With a focus on comfort,
              quality, and personalization, we specialize in luxury holidays,
              Char Dham Yatra, Hindu pilgrimage tours, Umrah packages, honeymoon
              getaways, and adventure tourism, as well as exclusive
              international vacations tailored to each traveler’s preferences.
            </p>
            <p>
              Our team of seasoned travel professionals ensures every detail is
              handled with precision — from seamless flight and hotel
              arrangements to visa assistance, travel insurance, and private
              transfers. We take pride in offering family holidays, corporate
              tours, group travel, and customized itineraries designed to match
              your interests, pace, and budget.
            </p>
            <p>
              Whether it’s a serene spiritual journey, a romantic escape, a
              thrilling adventure, or a luxurious global expedition,{" "}
              <b>M D Tours and Travels</b> delivers excellence at every step.
              Guided by trust, transparency, and personalized service, we
              continue to be Karnataka’s most preferred partner for meaningful
              and memorable travel experiences across the world.
            </p>

            <h2>What We Offer</h2>
            <p>
              We offer a wide range of travel solutions including domestic and
              international tour packages, honeymoon trips, adventure tours, and
              luxury holidays tailored to your style. Our expertise extends to
              Char Dham Yatra, Hindu pilgrimage tours, and Umrah packages with
              complete travel assistance. From flight bookings and visa support
              to hotel arrangements and private transfers, we handle every
              detail with care. With personalized planning and 24/7 support,{" "}
              <b>M D Tours and Travels </b>ensures every journey is seamless,
              comfortable, and unforgettable.
            </p>
          </div>

          {/* Meet the team section (ORIGINAL MODAL FUNCTIONALITY) */}
          <div>
            <section className="team-section">
              <h2 className="team-heading">Meet the Team</h2>
              <p className="team-text">
                The passionate travel experts behind your unforgettable
                journeys.
              </p>

              <div className="team-grid">
                {teamMembers.map((member, index) => (
                  <div
                    key={index}
                    className="team-card"
                    // Original click handler to open the modal
                    onClick={() => setSelectedMember(member)}
                  >
                    <img
                      src={member.image}
                      alt={member.name}
                      className="team-image"
                    />
                    <h3 className="team-name">{member.name}</h3>
                    <p className="team-role">{member.role}</p>
                  </div>
                ))}
              </div>

              {/* Conditional Modal Rendering */}
              {selectedMember && (
                <div className="modal-overlay" onClick={handleClose}>
                  <div
                    className="modal-content"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <button className="close-btn" onClick={handleClose}>
                      &times;
                    </button>
                    <img
                      src={selectedMember.image}
                      alt={selectedMember.name}
                      className="modal-image"
                    />
                    <h3 className="modal-name">{selectedMember.name}</h3>
                    <p className="modal-role">{selectedMember.role}</p>
                    <p className="modal-bio">{selectedMember.bio}</p>
                  </div>
                </div>
              )}
            </section>
          </div>

          {/* Airline partners section (SWIPER) */}
          <div>
            <section className="partners-section">
              <h2 className="partners-heading">Our Trade & Airline Partners</h2>
              <p className="partners-text">
                We collaborate with leading airlines and travel partners
                worldwide to bring you the best connectivity and comfort.
              </p>

              <div className="carousel-container partner-swiper-container">
                <Swiper {...swiperPartnersParams} className="partnerSwiper">
                  {partners.map((partner, index) => (
                    <SwiperSlide key={index}>
                      <div className="partner-card">
                        <img
                          src={partner.logo}
                          alt={partner.name}
                          className="partner-logo"
                        />
                      </div>
                    </SwiperSlide>
                  ))}
                  <div className="swiper-pagination-partners"></div>
                </Swiper>
              </div>
            </section>
          </div>

          {/* Hotel Prtners Section (SWIPER) */}
          <div>
            <section className="hotels-section">
              <h2 className="hotels-heading">
                Our Hotel & Hospitality Partners
              </h2>
              <p className="hotels-text">
                We partner with world-class hotels and resorts to ensure your
                stay is as luxurious and comfortable as your journey.
              </p>

              <div className="carousel-container hotel-swiper-container">
                <Swiper {...swiperPartnersParams} className="hotelSwiper">
                  {hotels.map((hotel, index) => (
                    <SwiperSlide key={index}>
                      <div className="hotel-card">
                        <img
                          src={hotel.logo}
                          alt={hotel.name}
                          className="hotel-logo"
                        />
                      </div>
                    </SwiperSlide>
                  ))}
                  <div className="swiper-pagination-partners"></div>
                </Swiper>
              </div>
            </section>
          </div>

          {/* Reviews section (SWIPER - Single Card Mobile) */}
          <div>
            <section className="reviews-section-carousel">
              <h2 className="reviews-carousel-heading">
                What Our Travelers Say
              </h2>
              <p className="reviews-carousel-subtitle">
                We take pride in creating memorable journeys for our clients.
                Here’s what they have to say!
              </p>

              <div className="carousel-container reviews-swiper-container">
                <Swiper {...swiperReviewParams} className="reviewSwiper">
                  {reviews.map((review, index) => (
                    <SwiperSlide key={index}>
                      <ReviewCard review={review} />
                    </SwiperSlide>
                  ))}

                  {/* Swiper Pagination and Navigation elements */}
                  <div className="swiper-pagination-reviews"></div>
                  <div className="swiper-button-prev swiper-button-prev-reviews"></div>
                  <div className="swiper-button-next swiper-button-next-reviews"></div>
                </Swiper>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;
